import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/modules/lucky_wheel/lights';

import Normal from './normal';
import Spin from './spin';

export default () => {
    const {wheel} = useSelector(Selector);

    if(wheel.status === 'spin' || wheel.status === 'spin-finale')
        return <Spin />

    return <Normal />;
}